
<template>
  <div>
    <el-form
      ref="entityData"
      :model="entityData"
      :rules="rules"
      label-width="100px"
      class="demo-ruleForm"
      label-position="right"
    >
      <el-row :gutter="20">
        <!-- 专利名称 -->

        <el-col :span="12">
          <el-form-item
            prop="zhuanLiMingCheng"
            label="专利名称"
          >
            <el-input
              v-model="entityData.zhuanLiMingCheng"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 授权国家 -->

        <el-col :span="12">
          <el-form-item
            prop="shouQuanGuoJia"
            label="授权国家"
          >
            <el-input
              v-model="entityData.shouQuanGuoJia"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 专利类型 -->

        <el-col :span="12">
          <el-form-item
            prop="zhuanLiLeiXingDictKey"
            label="专利类型"
          >
            <Combox
              v-model="entityData.zhuanLiLeiXingDictKey"
              type-id="D47"
              :option-data="getComboxData('D47')"
              :add-client="true"
            />
          </el-form-item>
        </el-col>

        <!-- 学科领域 -->

        <el-col :span="12">
          <el-form-item
            prop="xueKeLingYuDictKey"
            label="学科领域"
          >
            <Combox
              v-model="entityData.xueKeLingYuDictKey"
              type-id="D48"
              :option-data="getComboxData('D48')"
              :add-client="true"
            />
          </el-form-item>
        </el-col>

        <!-- 学科代码 -->

        <el-col :span="12">
          <el-form-item
            prop="xueKeDaiMa"
            label="学科代码"
          >
            <el-input
              v-model="entityData.xueKeDaiMa"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 类型 -->

        <el-col :span="12">
          <el-form-item
            prop="leiXingDictKey"
            label="类型"
          >
            <Combox
              v-model="entityData.leiXingDictKey"
              type-id="D49"
              :option-data="getComboxData('D49')"
              :add-client="true"
            />
          </el-form-item>
        </el-col>

        <!-- 分类 -->

        <el-col :span="12">
          <el-form-item
            prop="fenLeiDictKey"
            label="分类"
          >
            <Combox
              v-model="entityData.fenLeiDictKey"
              type-id="D50"
              :option-data="getComboxData('D50')"
              :add-client="true"
            />
          </el-form-item>
        </el-col>

        <!-- 类别 -->

        <el-col :span="12">
          <el-form-item
            prop="leiBieDictKey"
            label="类别"
          >
            <Combox
              v-model="entityData.leiBieDictKey"
              type-id="D51"
              :option-data="getComboxData('D51')"
              :add-client="true"
            />
          </el-form-item>
        </el-col>

        <!-- 全部发明人 -->

        <el-col :span="12">
          <el-form-item
            prop="quanBuFaMingRen"
            label="全部发明人"
          >
            <el-input
              v-model="entityData.quanBuFaMingRen"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 专利申请号 -->

        <el-col :span="12">
          <el-form-item
            prop="zhuanLiShenQingHao"
            label="专利申请号"
          >
            <el-input
              v-model="entityData.zhuanLiShenQingHao"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 专利申请日期 -->
        <el-col :span="12">
          <el-form-item
            prop="zhuanLiShenQingRiQi"
            label="专利申请日期"
          >
            <el-date-picker
              v-model="entityData.zhuanLiShenQingRiQi"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              type="date"
              style="width: 100%;"
            />
          </el-form-item>
        </el-col>

        <!-- 专利公开（公告）号 -->

        <el-col :span="12">
          <el-form-item
            prop="zhuanLiGongKaiHao"
            label="专利公开（公告）号"
          >
            <el-input
              v-model="entityData.zhuanLiGongKaiHao"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 专利公开（公告）日期 -->
        <el-col :span="12">
          <el-form-item
            prop="zhuanLiGongKaiRiQi"
            label="专利公开（公告）日期"
          >
            <el-date-picker
              v-model="entityData.zhuanLiGongKaiRiQi"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              type="date"
              style="width: 100%;"
            />
          </el-form-item>
        </el-col>

        <!-- 专利授权号 -->

        <el-col :span="12">
          <el-form-item
            prop="zhuanLiShouQuanHao"
            label="专利授权号"
          >
            <el-input
              v-model="entityData.zhuanLiShouQuanHao"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 专利授权日期 -->
        <el-col :span="12">
          <el-form-item
            prop="zhuanLiShouQuanRiQi"
            label="专利授权日期"
          >
            <el-date-picker
              v-model="entityData.zhuanLiShouQuanRiQi"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              type="date"
              style="width: 100%;"
            />
          </el-form-item>
        </el-col>

        <!-- 专利申请（权力）人 -->

        <el-col :span="12">
          <el-form-item
            prop="zhuanLiShenQingRen"
            label="专利申请（权力）人"
          >
            <el-input
              v-model="entityData.zhuanLiShenQingRen"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 署名位次 -->

        <el-col :span="12">
          <el-form-item
            prop="shuMingWeiCi"
            label="署名位次"
          >
            <el-input
              v-model="entityData.shuMingWeiCi"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 有效日期 -->
        <el-col :span="12">
          <el-form-item
            prop="youXiaoRiQi"
            label="有效日期"
          >
            <el-date-picker
              v-model="entityData.youXiaoRiQi"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              type="date"
              style="width: 100%;"
            />
          </el-form-item>
        </el-col>

        <!-- 助理 -->
        <el-col :span="12">
          <el-form-item
            prop="assitantList"
            label="助理"
          >
            <AssistEditForm
              v-model="entityData.assitantList"
              module-code="jx02"
            />
          </el-form-item>
        </el-col>

      </el-row>
    </el-form>
    <div class="dialog-footer">
      <el-button
        v-if="ketiInfo.isFuzeren || ketiInfo.isZuli"
        type="primary"
        @click="handleSave()"
      >
        保  存
      </el-button>
    </div>
  </div>
</template>
<script>
import pathReq from '@/api/pathlist'
import Combox from '@/views/managesystem/gz/com/Combox'
import AssistEditForm from '@/views/managesystem/gz/com/AssistEditForm.vue'
export default {
  components: {
    Combox, AssistEditForm
  },
  props: {
    // postId: { type: Number, default: null }
  },
  data() {
    return {
      entityId: null,
      entityData: {},
      allComboxData: [],
      rules: {
        zhuanLiMingCheng: [
          { required: true, message: '请输入专利名称', trigger: 'change,blur' }
        ]
      },
      selectedValue: [],
      ketiInfo: {}
    }
  },
  computed: {},
  created() {
    /** 下拉框数据 */
    pathReq.getComboxDatasByIdArray('D47;D48;D49;D50;D51').then(res => {
      this.allComboxData = res.data.result
    })
  },
  activated() {
    this.init()
  },
  methods: {
    // combox筛选值
    getComboxData(typeId) {
      return this.allComboxData.filter(function(item) {
        return item.typeId === typeId
      })
    },
    /**
     * 初始化数据
     */
    init() {
      this.entityId = this.$route.params.id
      if (!this.entityId) {
        this.$router.go(-1)
        return
      }
      const path = '/api/services/app/ky05/GetEditky05?Id=' + this.entityId
      pathReq.getNoParams(path).then(res => {
        this.entityData = res.data.result.entityData
      }).then(_ => {
        pathReq.getKetiInfo('ky05', this.entityData.id).then(r => {
          this.ketiInfo = r.data.result
        })
      })
    },
    /**
     * 打开数据字典弹出框
     */
    handleAddComboxData(dictTypeId, dictTypeName) {
      this.$bus.emit('comboxData', dictTypeId, dictTypeName)
    },
    /**
     * 新增或者修改身份信息数据
     */
    handleSave() {
      this.$refs['entityData'].validate(valid => {
        if (valid) {
          const that = this
          const path = '/api/services/app/ky05/CreateOrUpdateky05'

          pathReq
            .postForm(path, { entityData: that.entityData })
            .then(res => {
              that.$message.success('保存成功')
            })
        }
      })
    }
  }
}
</script>
<style scoped>
.el-dialog__body {
  padding-top: 10px !important;
}

.dialog-footer {
  text-align: right;
}

.el-select {
  margin-right: 8px;
  width: 84% !important;
}
</style>
